export const VALUE_CONTAINER_STYLE = {
  display: 'flex',
  alignItems: 'center',
  width: '114px',
} as const;

export const VALUE_FLAG_STYLE = {display: 'flex', height: 'auto'} as const;

export const VALUE_DIAL_CODE_STYLE = {
  fontSize: '16px',
  padding: '12px',
  fontWeight: 400,
  letterSpacing: 'inherit',
} as const;
